$(function(){
  
//   $('#listing').find('optgroup').clone().appendTo('.preset');  
  
//   product_rp_cart_div
  
  var frequency_number = $('[name="properties[frequency]"]:checked').data('number');

  function checkForBold() {
    if ($('.bold-ro__frequency-num, .frequency_num').length) {
      $('.bold-ro__recurring-radio-btn[value="1"]').click();
      
      $('.bold-ro__frequency-num, .frequency_num').focus().click().val(frequency_number).change().blur();
    } else {
      setTimeout(checkForBold, 100);
    }
  }
  
  checkForBold();
  
  $('.btn-quality').click(function(){

    $('.btn-quality').text("Select This Quality"); 

    $(".quality").removeClass("active"); 

    $(this).parents('.quality').addClass("active"); 

    $(this).text('Selected');

    $('#quality-change').val($(this).data('valueq'));
    $('#quality-name').val($(this).data('valueqt'));
  });

  $('.option-schedule').click(function(){
  userSelectedSchedule = true;
  $(".option-schedule").removeClass("active");
  $(this).addClass("active");
  $('#schedule-change').val($(this).data('sinfo'));
  fillInReviewOrderStep();
});

  $("#pick-your-filters").formToWizard({ submitButton: 'SaveAccount' })
  

  });


(function($) {
    $.fn.formToWizard = function(options) {
        options = $.extend({  
            submitButton: "" 
        }, options); 
        
        var element = this;

        var steps = $(element).find("section");
      	var tsteps = $(element).find("section").length;
        var count = steps.size();
        var submmitButtonName = "#" + options.submitButton;
        $(submmitButtonName).hide();
      
      var total = 0;

     console.log(steps);
      
        steps.each(function(i) {
          
            var checkmark = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 61.9 53.9" style="enable-background:new 0 0 61.9 53.9;" xml:space="preserve"><path class="st0" d="M47.3,2.2L23.8,33.5L13.9,25c-4-2.8-9.5-1.8-12.3,2.2c-2.4,3.4-2.1,8.1,0.9,11.1l15.1,13c4.2,3.6,10.5,3.3,14.4-0.7l28-36.3C63,10.6,62.4,5,58.6,2C55.3-0.8,50.5-0.6,47.3,2.2z"></path></svg>'
          
          	total++;
            $(this).wrap("<div id='step" + i + "'></div>");
            $(this).append("<ul id='step" + i + "commands' class='btn-wizard'></ul>");

            var name = $(this).find(".title").data('smalltitle');
            $("#steps").append("<a href='#' class='step current' id='stepDesc" + i + "' data-step='" + i + "'><div class='step-number'>"+checkmark+"<span>" + (i + 1) + "</span></div><div class='step-name'>" + name + "</div></a>");
          
//          	if(total!=tsteps){
//          	$("#steps").append("<div class='divider not-complete'></div>");
// 		    }

            if (i == 0) {
                createNextButton(i);
            }
            else if (i == count - 1) {
                $("#step" + i).hide();
                createPrevButton(i);
            }
            else {
                $("#step" + i).hide();
                createPrevButton(i);
                createNextButton(i);
            }
        });
      
        if ($('#pick-your-filters').data('cart-total') > 0) {
          fillInReviewOrderStep();
          selectStep(4);
          $('#step0, #step1, #step2, #step3, #step4, #step5').hide();
          $('#step4').show();
        }
      
        $('.step').click(function(e) {
          e.preventDefault();
          
          var currentStep = $('.step.current').data('step');
          var step = $(this).data('step');

          if (currentStep > step) {
            selectStep(step);
            $("#step0, #step1, #step2, #step3, #step4, #step5").hide();
            $("#step" + step).show();
          }
        });

        function createPrevButton(i) {
            var stepName = "step" + i;
            $("#" + stepName + "commands").append("<li><input id='" + stepName + "Prev' type='button' value='Prev Step' class='button'></li>");

            $("#" + stepName + "Prev").bind("click", function(e) {
                $("#" + stepName).hide();
                $("#step" + (i - 1)).show();
                $(submmitButtonName).hide();
                selectStep(i - 1);
            });
        }

        function createNextButton(i) {
  const stepName = "step" + i;
  $("#" + stepName + "commands").append(`<li><input id='${stepName}Next' type='button' value='Next Step' class='button'></li>`);

  $("#" + stepName + "Next").on("click", function (e) {
    let hasError = false;

    // 👉 Step 1: Validate Sizes (Custom requires input)
    if (i === 1) {
      $('.filter-size-select').each(function () {
        const $select = $(this);
        const val = $select.val();
        const $wrapper = $select.closest('.sizes-content');
        const $input = $wrapper.find('.extra-note-input');

        if (val === 'Custom') {
          if (!$input.val().trim()) {
            $input.addClass('input-error');
            if (!hasError) {
              $input[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
              $input.focus();
            }
            hasError = true;
          } else {
            $input.removeClass('input-error');
          }
        }
      });

      if (hasError) {
        e.preventDefault();
        alert("Please fill in all custom size fields before continuing.");
        return false;
      }
    }

    // 👉 Step 3: Require schedule selection
    if (i === 3) {
      const scheduleSelected = $('[name="properties[frequency]"]:checked').length > 0;
      if (!scheduleSelected) {
        e.preventDefault();
        alert("Please select a shipment schedule before continuing.");
        return false;
      }
    }

    // ✅ Continue to next step
    $(`#${stepName}`).hide();
    $(`#step${i + 1}`).show();
    if (i + 2 === count) $(submmitButtonName).show();

    selectStep(i + 1);
    fillInReviewOrderStep();
    addFiltersToCart();
  });
}


        function selectStep(i) {
            $('html, body').animate({
                scrollTop: ($('#steps').offset().top)
            }, 0);
          
            $("#steps a").removeClass("current");
            $("#stepDesc" + i).addClass("current");
        }

    }
})(jQuery); 
  

 (function ($) {
    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery); 



$('#pick-your-filters').on('submit',function(e){

 e.preventDefault();
  
 var checked= $('#quality-change').val();
  
  
  
 var dat = $(this).serializeFormJSON();
  
 $.ajax({
   type: 'POST',                             
   url: '/cart/add.js',  
   data: {
     
     id:checked,
     quantity:1,
     properties: dat
     
   }, 
    dataType: 'json',
      success: function(line_item) { 
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
    
        window.location = "/checkout";

          
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
});

});
  
  
  
  
  
  
  
  
  
  